// `GET /v1/me` (#12): everything about access comes from here, never from Firebase claims (D-06).
import { getGetMeQueryKey, getGetMeQueryOptions, type Me } from '@pa/api/me'
import { useQuery } from '@tanstack/react-query'

/** Frontend §3.3: 5 min; invalidated on sign-in, sign-out and password change. */
export const ME_STALE_TIME_MS = 5 * 60_000

export const meQueryOptions = () => getGetMeQueryOptions({ query: { staleTime: ME_STALE_TIME_MS } })
export const meQueryKey = () => getGetMeQueryKey()

export function useMe() {
  return useQuery(meQueryOptions())
}

export type { Me }

/** Active memberships, in `/v1/me` order (by clinic name). */
export const activeMemberships = (me: Me) => me.memberships.filter((m) => m.clinic.status === 'active')
